import { JSX } from 'react'

import { IconProps } from '../../icon'

const Lock: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M32.5128 19.6185V15.7949C32.5128 11.4954 29.0174 8 24.7179 8C20.4185 8 16.9231 11.4954 16.9231 15.7949V19.6185C14.1169 20.1928 12 22.6708 12 25.641V33.8462C12 37.2431 14.7569 40 18.1538 40H31.2821C34.679 40 37.4359 37.2431 37.4359 33.8462V25.641C37.4359 22.6708 35.319 20.1764 32.5128 19.6185ZM24.7179 10.4615C27.6554 10.4615 30.0513 12.8574 30.0513 15.7949V19.4872H19.3846V15.7949C19.3846 12.8574 21.7805 10.4615 24.7179 10.4615ZM34.9744 33.8462C34.9744 35.881 33.3169 37.5385 31.2821 37.5385H18.1538C16.119 37.5385 14.4615 35.881 14.4615 33.8462V25.641C14.4615 23.6062 16.119 21.9487 18.1538 21.9487H31.2821C33.3169 21.9487 34.9744 23.6062 34.9744 25.641V33.8462Z'
      fill='black'
    />
    <path
      d='M24.7179 26.0513C24.0451 26.0513 23.4872 26.6092 23.4872 27.2821V32.2051C23.4872 32.878 24.0451 33.4359 24.7179 33.4359C25.3908 33.4359 25.9487 32.878 25.9487 32.2051V27.2821C25.9487 26.6092 25.3908 26.0513 24.7179 26.0513Z'
      fill='black'
    />
  </svg>
)

export default Lock
